import React, { useContext, useState } from 'react';
import RemoveDialog from '../Shared/Remove/RemoveDialog';
import { useTenantsApp } from '../../Context/TenantsApp/TenantsAppContext';
import { DELETE_TENANT, DISABLE_TENANT, SET_TENANT_ID, TOGGLE_DISABLE_APP_DIALOG } from './TenantsAppEvents';
import { getProject, updateProject } from '../../API/Project/project';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import { disableAllInstancesOfApplicationOnRuntime } from '../Helpers/Runtime/runtime';
import { GlobalContext } from '../../Renderers/GlobalContext';
import { updateTenantProject } from '../../API/Tenant/Tenant';

const DisableTenantApp = () => {

    const context = useMsal();

    const { user } = useContext(GlobalContext).state

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    const { state, dispatch } = useTenantsApp();
    const [inProgress, setInProgress] = useState(false);

    const selectedTenant = state.tenants.find(tenant => tenant._id === state.selectedTenantId);
    if (!selectedTenant) return null;
    const project = selectedTenant.project;
    const { tenantProject } = project;

    const handleClose = () => {
        setInProgress(false);
        dispatch({ type: SET_TENANT_ID, payload: null });
        dispatch({ type: TOGGLE_DISABLE_APP_DIALOG });
    }

    const handleDisableTenantApp = async () => {
        setInProgress(true);
        const projectToDelete = await getProject(project.tenantProjectId)
        if (!projectToDelete) {
            dispatch({ type: DELETE_TENANT, payload: state.selectedTenantId });
            handleClose();
            return;
        }
        const [disableStatus, disableMessage] = await disableAllInstancesOfApplicationOnRuntime(
            context, projectToDelete.organizationId, projectToDelete.instances, projectToDelete.name
        );

        if (disableStatus === "error") {
            setInProgress(false);
            handleClose();
            return;
        }

        await Promise.allSettled([
            updateTenantProject(selectedTenant._id, selectedTenant.masterProjectId, { status: "disabled" }),
            updateProject(projectToDelete._id, {
                isActive: false,
                deletedBy: user._id,
                deletedOn: new Date()
            })
        ])
        dispatch({ type: DISABLE_TENANT, payload: { tenantId: state.selectedTenantId } });
        handleClose();
    }

    return (
        <RemoveDialog
            showLoader={inProgress}
            Title={t("disable_tenant_app")}
            toggleDeleteDialog={handleClose}
            message={t("disable_tenant_app_message", { tenantName: selectedTenant.tenantName })}
            message2={t("disable_tenant_app_message2")}
            onDelete={handleDisableTenantApp}
            onCancel={handleClose}
            deleteButtonText={t("disable_button")}
            cancelButtonText={t("cancel_button")}
        />
    );
}
export default DisableTenantApp;